<template>
  <div class="inner-page search-result-page">
    <app-layout ovflowFlowMain="auto">
      <app-header slot="header">
        <header-right slot="right"></header-right>
      </app-header>
      <a-spin size="large" :spinning="isLoading">
      <div class="inner-page__main" slot="default">
        <div class="inner-page__main__bg search-result--bg">
          <breadcrumb :navList="navList"></breadcrumb>
          <div class="inner-page__content">
            <div class="inner-page__content--header">
                <div class="inner-page__content--title">
                  <span class="title">全部课程</span>
                </div>
            </div>
            <div class="filter-button-list">
              <a-button v-for="(item, index) in filterButtonList" :key="index" @click="onFilterButtonClick(item.value)" :class="[activeButton === item.value ? 'active filter-button' : 'filter-button']" ghost>
                <span>{{item.label}}</span>
              </a-button>
            </div>
            <div class="course-wrap" v-if="courseList.length">
              <div class="course-list">
                <div class="item" v-for="(item, index) in courseList" :key="index">
                  <div class="item-img" @click="goTo('/coursePlayer', item.id)">
                    <img :src="`${item.img}`">
                  </div>
                  <div class="course-type-tag">{{item.typeName}}</div>
                  <div class="item-text">
                    <div class="title" @click="goTo('/coursePlayer', item.id)">
                      <div>
                        <div class="title-img" v-if="item.isNew">
                          <img src="../assets/images/index/new_tag@1x.png">
                        </div>
                        <span>{{item.title}}</span>
                      </div>

                      <h6>{{item.date}}</h6>
                    </div>
                    <div class="videoTime">
                      <div class="left">
                        <div class="time-img">
                          <img src="../assets/images/index/video@1x.png">
                        </div>
                        <span>{{item.videoTime | transformSecond}}分钟</span>
                      </div>
                      <div class="right" v-if="item.watchedTime && item.videoTime">
                        <span class="watched" v-if="item.watchedTime >= item.videoTime">已看完</span>
                        <span class="watching" v-else>
                          已观看<span>{{item.watchedTime | transformSecond}}</span>分钟
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="watchedProgress" v-if="item.watchedTime" :style="{width:`${item.watchedTime / item.videoTime * 100}%`}"></div>
                </div>
              </div>
              <pagination :total="total" @pageChange="onPageChange" @pageSizeChange="onPageSizeChange" :pageSizeOptions="pageSizeOptions"></pagination>
            </div>
            <empty v-else />
          </div>
        </div>
      </div>
      </a-spin>
    </app-layout>
  </div>
</template>

<script>
import HeaderRight from '../components/layout/header-right.vue'
import Breadcrumb from '../components/breadcrumb/breadcrumb.vue'
import Empty from '../components/empty/empty.vue'
import Pagination from '../components/pagination/pagination.vue'
import { course } from '@/api'
import eventHub from '@/event-hub'

export default {
  name: 'searchResult',
  components: { HeaderRight, Breadcrumb, Empty, Pagination },
  data () {
    return {
      filterButtonList: ['全部', '初级入门', '中级进阶', '高级应用', '综合流程'],
      activeButton: '',
      navList: [
        {
          text: '返回首页'
        }
      ],
      pageSizeOptions: ['12', '24', '36', '48', '60'],
      courseList: [],
      searchText: '',
      total: 100,
      pageSize: 12,
      isLoading: true
    }
  },
  filters: {
    transformSecond (second) {
      return Math.ceil(second / 60)
    }
  },
  created () {
    let { text } = this.$route.params || {}
    this.searchText = text
    this.navList.push({ text })
    Promise.all([this.searchCourse({
      page: 1,
      pageSize: this.pageSize
    }), this.getCourseCategory()]).then(() => {
    }).catch(() => {
      this.$message.error('请求数据失败')
    }).finally(() => {
      this.isLoading = false
    })
  },
  beforeDestroy () {
    eventHub.$off('searchCourse', this.onSearchCourse)
  },
  mounted () {
    this.onSearchCourse = this.onSearchCourse.bind(this)
    eventHub.$on('searchCourse', this.onSearchCourse)
  },
  methods: {
    getCourseCategory () {
      return course.courseCategory().then((res) => {
        let { data = [], status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.filterButtonList = data.map(item => {
          return {
            label: item.title,
            value: item.id
          }
        })
        this.filterButtonList.unshift({
          label: '全部',
          value: ''
        })
      })
    },
    onSearchCourse ({text}) {
      this.searchText = text
      this.navList.splice(1, 1, { text })
      this.searchCourse()
    },
    onFilterButtonClick (index) {
      this.activeButton = index
      this.searchCourse()
    },
    onPageChange ({pageNumber}) {
      let params = {
        page: pageNumber,
        pageSize: this.pageSize
      }
      this.searchCourse(params)
    },

    onPageSizeChange ({current, pageSize}) {
      let params = {
        page: current,
        pageSize: pageSize
      }
      this.pageSize = pageSize
      this.searchCourse(params)
    },

    searchCourse (params = {}) {
      this.isLoading = true
      let temp = {
        page: 1,
        pageSize: this.pageSize,
        ...params,
        title: this.searchText,
        cid: this.activeButton
      }
      course.searchResultList(temp).then(res => {
        let { data: { data, total }, status, msg = '' } = res || {}
        if (status !== 'success') {
          this.$message.error(msg)
          return res
        }
        this.courseList = data
        this.total = total
      }).catch(() => {
        this.$message.error('请求数据失败')
      }).finally(() => {
        this.isLoading = false
      })
    },
    goTo (path, id) {
      this.$router.push({path, query: { id }})
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../assets/style/index";
  .search-result--bg{
    min-height: 874px;
  }
  .filter-button-list{
    border-top: 1px solid rgba(216, 216, 216, 0.1); /*no*/
    padding-top: 15px;
    margin-top: 15px;
    .filter-button{
      font-size: 14px;
      color: @dateColor;
      margin-right: 12px;
      border-color: @dateColor;
      border-radius: 14px;
      line-height: 28px;
      height: 28px;
      &.active{
        color: @hoverColor;
        border-color: @hoverColor;
      }
    }
  }
  .course-wrap{
    border-top: 1px solid rgba(216, 216, 216, 0.1); /*no*/
    margin-top: 15px;
  }
  .course-list{
    display: flex;
    flex-wrap: wrap;
    padding: 0 0 36px 0;
    .item{
      margin: 35px 35px 0 0;
      width: 315px;
      height: 264px;
      background-color: @titleBgColor;
      border-radius: 6px;
      overflow: hidden;
      position: relative;
      &-img{
        img{
          width: 100%;
          height: 144px;
        }
      }
      &-text{
        color: @textColor;
        .title{
          font-size: 14px;
          padding: 13px 15px 15px 15px;
          border-bottom: 1px solid @lineColor; /*no*/
          &-img{
            img{
              width: 21px;
              height: 18px;
              margin-right: 6px;
            }
          }
          div{
            padding-bottom: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span{
              flex: 1;
              .ellipsis();
            }
          }
          h6{
            font-size: 12px;
            color: @dateColor;
            margin: 0;
          }
        }
        .videoTime{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-right: 15px;
          .left{
            flex: 1;
            font-size: 13px;
            display: flex;
            align-items: center;
          }
          .time-img{
            img{
              width: 42px;
              height: 42px;
            }
          }
          .right{
            font-size: 12px;
            color: @dateColor;
            .watched{
              color: @watched;
            }
            .watching{
              span{
                color: @hoverColor;
                padding: 0 4px;
              }
            }
          }
        }
      }
      .watchedProgress{
        height: 4px;
        background-color: @hoverColor;
        position: absolute;
        bottom: 0px; /*no*/
      }
      .course-type-tag{
        position: absolute;
        top: 15px;
        left: 0;
        background-color: @hoverColor;
        color: #fff;
        font-size: 12px;
        max-width: 72px;
        padding: 0 6px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
        .text-over()
      }
    }
    .item:nth-child(4n+0) {
      margin-right: 0;
    }
    .item:nth-child(-n+4) {
      margin-top: 25px;
    }
  }
</style>

<style lang="less">
  .search-result-page{
    .custom-dot{
      .ant-badge-dot{
        width: 5px;
        height: 5px;
        box-shadow: none;
      }
    }
  }
</style>